import { render, staticRenderFns } from "./ParcelNumberTemplate.vue?vue&type=template&id=cc02cec2&scoped=true&"
import script from "./ParcelNumberTemplate.vue?vue&type=script&lang=js&"
export * from "./ParcelNumberTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc02cec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc02cec2')) {
      api.createRecord('cc02cec2', component.options)
    } else {
      api.reload('cc02cec2', component.options)
    }
    module.hot.accept("./ParcelNumberTemplate.vue?vue&type=template&id=cc02cec2&scoped=true&", function () {
      api.rerender('cc02cec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/ParcelNumberTemplate.vue"
export default component.exports